var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('settings-container',{attrs:{"title":"Members"}},[_c('p',[_vm._v(" These are the current members who are part of your organisation. ")]),_c('user-list',{attrs:{"orgId":_vm.organisation.id}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }